import React from 'react';
import { connect } from 'react-redux';
import { mapStateToProps, mapDispatchToProps } from '../Store';
import Layout from '../components/layouts/Layout';
import SEO from '../components/seo';

export const Faqs = ({ user, notification, actions }) => {
    return (
        <Layout user={user} notification={notification} actions={actions}>
            <SEO title="FAQS" />
            <FaqsInner />
        </Layout>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(Faqs);

export const FaqsInner = () => {
    return (
        <div className="container">
            <div className="title">
                <h1 style={centerTitle}>FAQS</h1>
            </div>
            <div className="content-container question-container">
                <div>
                    <h2 style={centerTitle}>
                        QUESTIONS ABOUT YOUR ILLINOIS LOTTERY <br />2
                        <sup>nd</sup> CHANCE ACCOUNT
                    </h2>
                </div>
                <div>
                    <div style={qaBlock}>
                        <p>
                            <strong>
                                Q: How do I update my personal information that
                                I submitted when I registered?
                            </strong>
                        </p>
                        <p>
                            A: Log in using the email address and password that
                            you registered when you joined. Then click on My
                            Profile to go to your player account page and
                            makeany needed updates. Click Submit at the bottom
                            of the form when you are finished.
                        </p>
                    </div>

                    <div style={qaBlock}>
                        <p>
                            <strong>
                                Q: What should I do if I can’t remember my
                                password?
                            </strong>
                        </p>
                        <p>A: Reset your password.</p>
                    </div>

                    <div style={qaBlock}>
                        <p>
                            <strong>
                                Q: What should I do if I encounter a problem
                                with the Illinois 2nd Chance website?
                            </strong>
                        </p>
                        <p>
                            A: Click on Feedback to submit your question or
                            problem. We will assist you via return email. The
                            more details you can provide the better chance we
                            will have of quickly resolving an issue.
                        </p>
                    </div>
                </div>

                <div>
                    <h2 style={centerTitle}>
                        QUESTIONS ABOUT ENTRIES AND TICKETS
                    </h2>
                </div>
                <div>
                    <div style={qaBlock}>
                        <p>
                            <strong>
                                Q: Which tickets are eligible for THE PRICE IS
                                RIGHT&trade; 2nd Chance Promotion drawing?
                            </strong>
                        </p>
                        <p>
                            A: Any eligible non-winning THE PRICE IS
                            RIGHT&trade; (Game 7473) instant ticket for Illinois
                            Lottery that you purchase during the promotion
                            period of the game are eligible. One ticket is
                            required per entry.
                        </p>
                        <table className="table">
                            <thead>
                                <tr>
                                    <th>Game Number</th>
                                    <th>Eligible Scratch Tickets</th>
                                    <th>Ticket Price</th>
                                    <th>Entries Awarded</th>
                                    <th>Launch Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td data-title="Game Number">7473</td>
                                    <td data-title="Eligible Scratch Tickets">
                                        THE PRICE IS RIGHT&trade;
                                    </td>
                                    <td data-title="Ticket Price">$5</td>
                                    <td data-title="Entries Awarded">
                                        Up to 125 entries
                                    </td>
                                    <td data-title="Launch Date">8/1/22</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div style={qaBlock}>
                        <p>
                            <strong>
                                Q: Can I enter the Illinois 2nd Chance drawings
                                more than one time?
                            </strong>
                        </p>
                        <p>
                            A: Yes, a player may enter a maximum of 25 eligible
                            tickets per day based on the specified instant game.
                            Each entry requires the submission of an eligible
                            non-winning THE PRICE IS RIGHT&trade; instant ticket
                            for Illinois Lottery that has not yet been
                            submitted.
                        </p>
                    </div>
                    <div style={qaBlock}>
                        <p>
                            <strong>
                                Q: How can I be sure that my internet entry has
                                been submitted?
                            </strong>
                        </p>
                        <p>
                            A: When you submit an entry, a record of it appears
                            at the bottom of your <a href="enter/">Enter Now</a>{' '}
                            page. If the entry is recorded there, you can be
                            assured that it is in the system.
                        </p>
                    </div>
                    <div style={qaBlock}>
                        <p>
                            <strong>
                                Q: What is the entry deadline for the Illinois
                                2nd Chance drawings?
                            </strong>
                        </p>
                        <p>
                            A: All entries are due by 11:59:59 PM CST on the
                            drawing deadline.
                        </p>
                    </div>
                    <div style={qaBlock}>
                        <p>
                            <strong>
                                Q: Can I throw away my tickets after submitting
                                them into the Illinois 2nd Chance drawing?
                            </strong>
                        </p>
                        <p>
                            A: Yes, a ticket is not required to claim prize. You
                            may wish to keep the tickets for your records.
                        </p>
                    </div>
                    <div style={qaBlock}>
                        <p>
                            <strong>
                                Q: When will THE PRICE IS RIGHT&trade; instant
                                ticket be available for purchase?
                            </strong>
                        </p>
                        <p>
                            A: THE PRICE IS RIGHT&trade; instant game will
                            launch on August 1, 2022.
                        </p>
                    </div>
                </div>

                <div>
                    <h2 style={centerTitle}>QUESTIONS ABOUT WINNERS</h2>
                </div>
                <div>
                    <div style={qaBlock}>
                        <p>
                            <strong>
                                Q: What are my chances of winning the prize in
                                the Illinois 2nd Chance drawings?
                            </strong>
                        </p>
                        <p>
                            A: Your odds of winning are based on the total
                            number of entries received for the drawing and the
                            total number of entries that you have submitted.
                        </p>
                    </div>
                    <div style={qaBlock}>
                        <p>
                            <strong>
                                Q: How will I be notified if I win the prize?
                            </strong>
                        </p>
                        <p>
                            A: If your entry is selected, you will be notified
                            by the Lottery using the contact information in your
                            player account so please make sure that all of your
                            information is up-to-date. All winners’ information
                            will be posted on the{' '}
                            <a href="winners">Drawings & Winners</a> page after
                            winners have been verified.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

// CSS STYLE OBJECTS
const centerTitle = {
    color: '#9B1717',
    textAlign: 'center',
};

const qaBlock = {
    paddingTop: '1rem',
    paddingBottom: '1rem',
};
